import React, { useState } from 'react';
import axios from 'axios';
import { SnackbarProvider } from "baseui/snackbar";
import { ApiConstant } from '../../../../../constants';
import { pushLog2DV2LogServer } from '../../../../../services/logging';
import { getUserObject } from '../../../../util/getUserFullName';

const MobilePageContainer = ({ HeaderComponent, MainBodyComponent, api_data = { endpoint: null, body: {} }, event_name }) => {
    const [mailSent, setMailSent] = useState(false);
    const [mailError, setMailError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showNotification, setShowNotification] = useState(false)

    const resetNotifications = () => {
        setShowNotification(false);
    }

    const sendDesktopLoginMail = async () => {
        const { endpoint, body } = api_data; // Ensure we destructure `endpoint` and `body` here
        if (!endpoint) {
            console.error("API endpoint is missing");
            return;
        }
        const { uid, email } = getUserObject() || {}
        setLoading(true);
        setMailError(false);
        try {
            const response = await axios.post(`${ApiConstant.BASE_URL}${endpoint}`, body);
            if (response.data && response.data.success) {
                setMailSent(true);
                pushLog2DV2LogServer.info(
                    "MOBILE_SCREEN_BLOCKER_LOGGING",
                    event_name ? event_name : "MOBILE_SCREEN_BLOCKER_V1",
                    { email, user_id: uid },
                    { page: "MOBILE_SCREEN_BLOCKER", currentUrl: window.location.href, email, user_id: uid },
                    null
                );
            }
        } catch (e) {
            setMailError(true);
            pushLog2DV2LogServer.error(
                "MOBILE_SCREEN_BLOCKER_LOGGING",
                event_name ? event_name : "MOBILE_SCREEN_BLOCKER_V1",
                { email, user_id: uid },
                { page: "MOBILE_SCREEN_BLOCKER", currentUrl: window.location.href, email, user_id: uid },
                { error_message: e.message }
            )
        } finally {
            setShowNotification(true)
            setLoading(false);
        }
    };

    return (
        <SnackbarProvider>
            {HeaderComponent ? <HeaderComponent /> : null}
            <MainBodyComponent 
                mail_sent={mailSent} 
                sending_error={mailError} 
                sendDesktopLoginMail={sendDesktopLoginMail} 
                loading={loading}
                resetNotifications={resetNotifications}
                showNotification={showNotification}
            />
        </SnackbarProvider>
    );
};

export default MobilePageContainer;
